import React from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import Projects from '../projects/projects';

const ProjectsPage = () => {
    return (
        <div className="projects-page">
            <NavigationBar />

            <main className="projects-main">
                <Projects />
            </main>

        </div>
    );
};

export default ProjectsPage;